import Image from 'global/Image';
import PropTypes from 'prop-types';

const BigAvatar = ({
  avatar: avatarProps,
  temp_avatar: tempAvatar,
  avatar_override: avatarOverRide,
  hide_loader: hideLoader,
  overlayClassName,
  state,
  onAvatarError,
  handleImageOnLoad,
  avatarURL,
}) => {
  const { avatarClass } = state;
  let image;

  if (avatarProps || avatarProps === '') {
    if (avatarProps.match(/\bhttp/i)) {
      image = avatarProps;
    } else {
      image = `${avatarURL}/${avatarProps}`;
    }
  } else {
    image = null;
  }

  let avatar = tempAvatar || image;
  let clsLoader = '';

  if (hideLoader && avatar) clsLoader = 'hide';
  if (avatarOverRide) avatar = avatarProps;

  return (
    <div>
      <div className={`PrimarySpinner ${clsLoader}`} />
      {!hideLoader && <p>Uploading..</p>}

      <i>
        <Image
          alt="avatar"
          src={avatar}
          style={{ opacity: 1 }}
          className={`${avatarClass} ${overlayClassName}`}
          onError={onAvatarError}
          onLoad={handleImageOnLoad}
        />
      </i>
    </div>
  );
};

BigAvatar.propTypes = {
  avatar: PropTypes.string,
  temp_avatar: PropTypes.string,
  avatar_override: PropTypes.string,
  hide_loader: PropTypes.bool,
  overlayClassName: PropTypes.string,
  state: PropTypes.shape({
    avatarDiv: PropTypes.string,
    avatarClass: PropTypes.string,
  }),
  onAvatarError: PropTypes.func,
  handleImageOnLoad: PropTypes.func,
  avatarURL: PropTypes.string.isRequired,
};

BigAvatar.defaultProps = {
  avatar: '',
  temp_avatar: '',
  avatar_override: '',
  hide_loader: true,
  overlayClassName: '',
  state: {
    avatarDiv: null,
    avatarClass: '',
  },
  onAvatarError: () => {},
  handleImageOnLoad: () => {},
};

export default BigAvatar;
